import { Body, Caption, Shape, styled } from '@teko/ds-desktop';
import { DownOutlined, LocationPickerColored } from '@teko/ds-icon';
import { Dropdown, DropdownMenu, DropdownToggle } from '@teko/ui';
import { useDistanceTerminalContext } from 'contexts';
import { t } from 'i18n';
import dynamic from 'next/dynamic';
import { useCallback, useState } from 'react';
import { NavItem } from 'tenants/_template/desktop/_module/components/NavigationBar';

const MiniTerminalPicker = dynamic(() =>
  import('./MiniTerminalPicker').then((mod) => mod.MiniTerminalPicker),
);

export const TerminalOverview = () => {
  const { currentTerminal } = useDistanceTerminalContext();
  const [miniCartOpen, setMiniCartOpen] = useState(false);

  const toggleMiniCart = useCallback(() => {
    setMiniCartOpen(!miniCartOpen);
  }, [miniCartOpen]);

  return (
    <StyledDropdown
      isOpen={miniCartOpen}
      toggle={toggleMiniCart}
      toggleType="hover"
      onHide={(): void => setMiniCartOpen(false)}
    >
      <DropdownToggle>
        <NavItem className="att-home-page-delivery-area">
          <LocationPickerColored size={20} />
          <Shape>
            <Caption color="textSecondary">{t('Xem sản phẩm tại')}</Caption>
            {!!currentTerminal?.terminalName ? (
              <Body level={2} weight="medium" maxWidth="128px" line={1}>
                {currentTerminal?.terminalName}
              </Body>
            ) : (
              <Body level={2} weight="medium">
                {t('Chưa có siêu thị được chọn')}
              </Body>
            )}
          </Shape>
          <DownOutlined size={20} />
        </NavItem>
      </DropdownToggle>
      <DropdownMenu popperConfig={{ placement: 'top-end' }}>
        <MiniTerminalPicker />
      </DropdownMenu>
    </StyledDropdown>
  );
};

const StyledDropdown = styled(Dropdown)`
  width: auto;
  position: relative;
`;
